<ng-container *transloco="let convert;">
  <div
    class="modal--action-list"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.actionListErrorModal.ariaLabelErrorModal')">

    <div class="modal__content">
      <div class="modal__body">
        <div>
          <span class="pt-1 pe-4"><app-error-icon [fill]="'#d42925'"></app-error-icon></span>
          {{ errorMessage$() }}
        </div>
        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            [attr.aria-label]="convert('common.btnClose')"
            (click)="closeModal()">
            <span>{{convert('common.btnClose')}}</span>
          </button>
        </div>
      </div>
    </div>

    @if (configuration$()) {
      <button
        class="modal__close"
        data-dismiss="modal"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="closeModal()"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close">
        <img
          src="../../../../../ui/assets/assets-{{ configuration$().tenantName }}/{{ configuration$().tenantName }}-close.svg"
          alt="{{convert('common.altCloseModelIcon')}}"/>
      </button>
    }
  </div>
</ng-container>

